
import { ordersSelectors } from '@/entities/orders'
import { RootState } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { getInboxRowFromOrder } from '../libs/getInboxRowFromOrder'
import { replacePlanningInboxRows } from '../slices/planningInboxTableSlice'

// TODO: the following inbox table rows is missing assigned shifts/scenarios. The reason is that it is 
//    inconvient to keep track of assigned order to shift mapping state on the client side
//    and can cause descrepancies with the server.
export const updatePlanningInboxTableRows = createAsyncThunk<void, void, { state: RootState }>(
  'planningInboxTable/update',
  async (_, { getState, dispatch }) => {
    const state = getState()
    const orders = ordersSelectors.selectAll(state)

    if (!orders) {
      throw new Error('Redux thunk error [planningInboxTable/update]: orders not found')
    }

    const inboxRows = orders.map((order) => getInboxRowFromOrder(order))

    dispatch(replacePlanningInboxRows(inboxRows))
  },
)
